import { flowRight, reduce } from "lodash"
const makeOptional = (optional) => (optional != null ? `/${optional}` : "")

export const routeTemplatesBase = [
  {
    id: "confirm",
    config: "/confirm/:tab?",
    build: (tab) => `/confirm${makeOptional(tab)}`,
  },
  {
    id: "sessionKey",
    config: "/sessionKey/:sid",
    build: (sid) => `/sessionKey/${sid}`,
  },
  {
    id: "info",
    config: "/info/:pid/:sid/:aid",
    build: (pid, sid, aid) => `/info/${pid}/${sid}/${aid}`,
  },
  {
    id: "eula",
    config: "/eula/:sid/:aid",
    build: (sid, aid) => `/eula/${sid}/${aid}`,
  },
  {
    id: "nda",
    config: "/nda/:pid/:sid/:aid",
    build: (pid, sid, aid) => `/nda/${pid}/${sid}/${aid}`,
  },
  {
    id: "finish",
    config: "/finish/:pid/:sid/:aid",
    build: (pid, sid, aid) => `/finish/${pid}/${sid}/${aid}`,
  },
  {
    id: "registration",
    config: "/registration/:pid/:sid/:ast/:aid",
    build: (pid, sid, ast, aid) => `/registration/${pid}/${sid}/${ast}/${aid}`,
  },
  {
    id: "page",
    config: "/page/:pid/:sid/:ast/:aid",
    build: (pid, sid, ast, aid) => `/page/${pid}/${sid}/${ast}/${aid}`,
  },
  {
    id: "results",
    config: "/results/:sid/:aid/:viewMode",
    build: (sid, aid, viewMode, optional) => `/results/${sid}/${aid}/${viewMode}${optional || ""}`,
  },
  {
    id: "annotations",
    config: "/results/:sid/:aid/:viewMode/annotations/:questionId",
    build: ({ aid, questionId, sid, viewMode }) =>
      `/results/${sid}/${aid}/${viewMode}/annotations/${questionId}`,
  },
  {
    id: "error",
    config: "/error/:errorCode",
    build: (errorCode) => `/error/${errorCode}`,
  },
  {
    id: "exam",
    config: "/exam/:sid/:aid/:optional?",
    build: (sid, aid, optional) => `/exam/${sid}/${aid}${makeOptional(optional)}`,
  },
  {
    id: "notReady",
    config: "/notReady/:sid",
    build: (sid) => `/notReady/${sid}`,
  },
  {
    id: "previewStart",
    config: "/previewStart/:sid",
    build: (sid) => `/previewStart/${sid}`,
  },
  {
    id: "anonymousStart",
    config: "/anonymousStart/:sid",
    build: (sid) => `/anonymousStart/${sid}`,
  },
  {
    id: "keycodeStart",
    config: "/keycodeStart/:sid",
    build: (sid) => `/keycodeStart/${sid}`,
  },
  {
    id: "logoff",
    config: "/logoff",
    build: () => "/logoff",
  },
  {
    id: "redirectFromDeliveryV2ToStartExam",
    config: "/redirectFromDeliveryV2/startExam/:sid",
    build: (sid) => `/redirectFromDeliveryV2/startExam/${sid}`,
  },
]

// TODO: add validate function that verify all child routes has parent route as substring at the start of string

const flattenRouteTemplates = (routes) => {
  let flattenedRouteTemplates = []

  routes.forEach((rt) => {
    flattenedRouteTemplates.push(rt)

    if (rt.children != null) {
      flattenedRouteTemplates = flattenedRouteTemplates.concat(flattenRouteTemplates(rt.children))
    }
  })

  return flattenedRouteTemplates
}

const reduceRouteTemplates = (routes) => {
  return reduce(
    routes,
    (reducedRouteTemplates, rt) => {
      return {
        ...reducedRouteTemplates,
        [rt.id]: {
          ...rt,
          children: rt.children != null ? flattenRouteTemplates(rt.children) : [],
        },
      }
    },
    {},
  )
}

const result = flowRight(reduceRouteTemplates, flattenRouteTemplates)(routeTemplatesBase)

export const routeTemplates = result
